var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCtaIconsDispatchOrdersToBjs({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.645,
    height: 18,
    viewBox: "0 0 19.645 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-20 -8)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.895 -16)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8.812,
    height: 9.442,
    transform: "translate(25.518 25)",
    fill: "#3a3630"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "translate(24 28)",
    fill: "#3a3630"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.394,3H6.163A1.357,1.357,0,0,0,4.808,4.356v.452H4.356A1.357,1.357,0,0,0,3,6.163v7.231A1.357,1.357,0,0,0,4.356,14.75h7.231a1.357,1.357,0,0,0,1.356-1.356v-.452h.452a1.357,1.357,0,0,0,1.356-1.356V4.356A1.357,1.357,0,0,0,13.394,3Zm-2.26,9.716a.226.226,0,0,1-.226.226H5.034a.226.226,0,0,1-.226-.226v-.452a.226.226,0,0,1,.226-.226h5.875a.226.226,0,0,1,.226.226Zm0-1.808a.226.226,0,0,1-.226.226H5.034a.226.226,0,0,1-.226-.226v-.452a.226.226,0,0,1,.226-.226h5.875a.226.226,0,0,1,.226.226Zm0-1.808a.226.226,0,0,1-.226.226H5.034A.226.226,0,0,1,4.808,9.1V8.649a.226.226,0,0,1,.226-.226h5.875a.226.226,0,0,1,.226.226Zm0-1.808a.226.226,0,0,1-.226.226H5.034a.226.226,0,0,1-.226-.226V6.841a.226.226,0,0,1,.226-.226h5.875a.226.226,0,0,1,.226.226Zm2.712,4.293a.452.452,0,0,1-.452.452h-.452V6.163a1.357,1.357,0,0,0-1.356-1.356H5.712V4.356A.452.452,0,0,1,6.163,3.9h7.231a.452.452,0,0,1,.452.452Z",
    transform: "translate(20 22)",
    fill: "#feba30"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(20 8)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M151.063,8.951H148.44a.576.576,0,0,1-.577-.577V4.727h-.908A.581.581,0,0,1,146.5,3.8L149.3.219a.579.579,0,0,1,.908,0L153,3.8a.581.581,0,0,1-.454.931h-.908V8.374A.576.576,0,0,1,151.063,8.951Z",
    transform: "translate(-141.982 0)",
    fill: "#6396e5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32,154.623v6.535a.58.58,0,0,0,.35.531l7.243,3.093a.6.6,0,0,0,.454,0l7.147-3.093a.577.577,0,0,0,.346-.531v-6.439l-1.154.862v5.2L40.4,163.374v-5.512l6.77-2.577a.582.582,0,0,0-.008-1.081l-4.146-1.5-.4,1.081,2.689.973-5.485,2.089-5.574-2.108,2.535-.912-.388-1.085-4.012,1.439a.583.583,0,0,0-.008,1.085",
    transform: "translate(-32 -146.826)",
    fill: "#b4b4b4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245,228.647l6.566-2.523-.077-5.924-6.439,2.177Z",
    transform: "translate(-236.807 -211.73)",
    fill: "#acacac"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCtaIconsDispatchOrdersToBjs);
export default __webpack_public_path__ + "static/media/ctaIcons_DispatchOrdersToBJS.9870e43e5d76172dedaa64d3590a3c82.svg";
export { ForwardRef as ReactComponent };